// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Colors from "common/src/Colors.bs.js";

function PositionSquare2(Props) {
  var sOpt = Props.size;
  var pl = Props.pl;
  var queueIdOpt = Props.queueId;
  var s = sOpt !== undefined ? sOpt : 32;
  var queueId = queueIdOpt !== undefined ? queueIdOpt : 1100;
  var pl$1 = queueId !== 1150 && queueId !== 1160 ? pl : (pl + 1 | 0) / 2 | 0;
  var tmp;
  switch (pl$1) {
    case 1 :
        tmp = Colors.legendaryDesaturated2;
        break;
    case 2 :
        tmp = Colors.epicDesaturated2;
        break;
    case 3 :
        tmp = Colors.rareDesaturated2;
        break;
    case 4 :
        tmp = Colors.uncommonDesaturated2;
        break;
    default:
      tmp = Colors.common;
  }
  var c = "#" + tmp;
  return React.createElement("svg", {
              height: String(s),
              width: String(s),
              viewBox: "0 0 32 32"
            }, React.createElement("rect", {
                  height: "32",
                  width: "32",
                  fill: c,
                  opacity: "0.1",
                  rx: "6",
                  ry: "6"
                }), React.createElement("rect", {
                  height: "29.5",
                  width: "29.5",
                  fill: "transparent",
                  rx: "6",
                  ry: "6",
                  stroke: c,
                  strokeWidth: "2.25",
                  x: "1.25",
                  y: "1.25"
                }), React.createElement("text", {
                  fill: c,
                  fontFamily: "Montserrat",
                  fontSize: "25",
                  fontWeight: "600",
                  textAnchor: "middle",
                  x: "15.5",
                  y: "25"
                }, String(pl$1)));
}

var make = PositionSquare2;

export {
  make ,
  
}
/* react Not a pure module */
